import { getAttribute, getCssVar, updateAttribute } from '../utils/dom';
const vs16RegExp = /\uFE0F/g;
const zeroWidthJoiner = String.fromCharCode(0x200d);
const removeVS16s = rawEmoji => rawEmoji.indexOf(zeroWidthJoiner) < 0 ? rawEmoji.replace(vs16RegExp, '') : rawEmoji;
function toCodePoints(unicodeSurrogates) {
  const points = [];
  let char = 0;
  let previous = 0;
  let i = 0;
  while (i < unicodeSurrogates.length) {
    char = unicodeSurrogates.charCodeAt(i++);
    if (previous !== 0) {
      points.push((0x10000 + (previous - 0xd800 << 10) + (char - 0xdc00)).toString(16));
      previous = 0;
    } else if (char > 0xd800 && char <= 0xdbff) {
      previous = char;
    } else {
      points.push(char.toString(16));
    }
  }
  return points;
}
const BASE_URL_ATTR = 'data-emoji-base-url';
export const setEmojiBaseUrl = (emojiEl, baseUrl) => {
  updateAttribute(emojiEl, BASE_URL_ATTR, baseUrl);
};
export const getEmojiBaseUrl = root => {
  let baseUrl = getAttribute(root, BASE_URL_ATTR);
  if (baseUrl !== null) {
    return baseUrl;
  }
  baseUrl = getCssVar(root, '--sinch-emoji-src-url');
  if (baseUrl !== null) {
    return baseUrl.replaceAll('"', '').trim();
  }
  return null;
};
export const getEmojiUrl = (baseUrl, char) => {
  if (char === null || char.length === 0 || baseUrl === null) {
    return '';
  }
  let codepoints = toCodePoints(removeVS16s(char)).join('-');
  if (codepoints === '1f441-fe0f-200d-1f5e8-fe0f') {
    codepoints = '1f441-200d-1f5e8';
  }
  return baseUrl.replace('%s', codepoints);
};